import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError.ts';
import { EICFTemplatesApi } from '../../../apis/EICFApi/EICFTemplatesApi.ts';
import { IEICFFacilityAssignmentRequest } from '../EICFTemplate.ts';

export function useAssignEICFTemplate() {
    const queryClient = useQueryClient();
    return useMutation<void, AppMedError, IEICFFacilityAssignmentRequest>({
        mutationKey: [QueryKeys.eicfTemplates, 'assign'],
        mutationFn: (req) => EICFTemplatesApi.assignToFacility(req),
        onSuccess: (_data, req) => {
            queryClient.invalidateQueries({ queryKey: [QueryKeys.eicfFacilityActiveTemplate, req.healthcareFacilityID] });
        },
    });
}
